module.exports = __webpack_public_path__ + "img/section2Logo4.24912105.png";